import React from 'react';

// Renders plain text with paragraphs/line breaks preserved and simple **bold** / *italic* markers.
const inline = (text, keyBase) => text.split(/(\*\*[^*]+\*\*|\*[^*]+\*)/g).filter(Boolean).map((part, i) => {
  if (part.startsWith('**') && part.endsWith('**')) return <strong key={`${keyBase}-${i}`} className="text-cream font-semibold">{part.slice(2, -2)}</strong>;
  if (part.startsWith('*') && part.endsWith('*')) return <em key={`${keyBase}-${i}`}>{part.slice(1, -1)}</em>;
  return <React.Fragment key={`${keyBase}-${i}`}>{part}</React.Fragment>;
});

export default function RichText({ text, className = '' }) {
  if (!text) return null;
  const paragraphs = text.replace(/\r\n/g, '\n').split(/\n{2,}/);
  return (
    <div className={`space-y-3 ${className}`} data-testid="rich-text">
      {paragraphs.map((p, pi) => (
        <p key={pi}>
          {p.split('\n').map((line, li, arr) => (
            <React.Fragment key={li}>{inline(line, `${pi}-${li}`)}{li < arr.length - 1 && <br />}</React.Fragment>
          ))}
        </p>
      ))}
    </div>
  );
}
